import React, {useState, useEffect} from 'react';

const NbCharsRestriction = ({radioBoxPrefix, value, onChange}) => {

  const [model, setModel] = useState(value || {});

  const setModelAndNotifyParent = newModel => {
    setModel(newModel);
    onChange(newModel);
  }

  useEffect(() => {
    setModel(value || {});
  }, [ value ]);

  return <div className="mb-2">
    <div className="form-check mb-1">
      <input id={radioBoxPrefix + 'NbCharsRestrEnabled'}
             type="checkbox"
             className="form-check-input"
             checked={model.enabled == null ? false : model.enabled}
             onChange={e => setModelAndNotifyParent({...model, ...{enabled: e.target.checked}})} />
      <label className="form-check-label" htmlFor={radioBoxPrefix + 'NbCharsRestrEnabled'}>
        Restrict the number of characters
      </label>
    </div>
    {model.enabled &&
      <div className="row justify-content-end">
        <div className="col-11">
          <div className="mb-3">
            <label htmlFor="nbCharsRestrMin" className="form-label">Minimum number of characters</label>
            <input id="nbCharsRestrMin" name="nbCharsRestrMin"
                   type="number"
                   className="form-control"
                   value={model.min == null ? 0 : model.min}
                   onChange={e => setModelAndNotifyParent({
                     ...model,
                     ...{min: e.target.value ? parseInt(e.target.value) : 0}
                   })}
                   min="0"/>
          </div>
        </div>
        <div className="col-11">
          <div className="mb-3">
            <label htmlFor="nbCharsRestrMax" className="form-label">Maximum number of characters</label>
            <input id="nbCharsRestrMax" name="nbCharsRestrMax"
                   type="number"
                   className="form-control"
                   value={model.max == null ? '' : model.max}
                   onChange={e => setModelAndNotifyParent({
                     ...model,
                     ...{max: e.target.value ? parseInt(e.target.value) : null}
                   })}
                   min="1"/>
          </div>
        </div>
      </div>
    }
  </div>;
}

export default NbCharsRestriction;
